import { AuthContext } from '@monash/portal-frontend-common';
import { useContext } from 'react';
import UserCard from '../user-card/UserCard';
import UserSearch from '../UserSearch';
import c from './real-users.module.scss';
import RecentSearches from '../recent-searches/RecentSearches';
import useLocalStorage from '../../../../hooks/use-local-storage';
import { IdSearch } from '../id-search/IdSearch';
import GetApiResponses from '../get-api-responses/GetApiResponses';
import ACCESS_ROLES from '../../../../constants/user-roles';
import AvailableApplications from '../available-applications/AvailableApplications';

const RealUsers = ({
  currentlyImpersonating,
  startImpersonation,
  endImpersonation,
}) => {
  const [recentSearches, setRecentSearches] = useLocalStorage(
    'recentSearches',
    []
  );

  const { user } = useContext(AuthContext);

  const canGetApiResponses = [
    ACCESS_ROLES.ADMIN,
    ACCESS_ROLES.SUPPORT_DEVELOPER,
  ].some((x) => user?.roles?.includes(x));

  return (
    <div className={c.realUsers}>
      <div className={c.impersonationWrapper}>
        {currentlyImpersonating && (
          <>
            <div className={c.impersonateeContainer}>
              <h2>Currently Impersonating</h2>
              <UserCard
                data={currentlyImpersonating}
                onEnd={endImpersonation}
                active
              />
            </div>

            <AvailableApplications />

            {canGetApiResponses && !currentlyImpersonating.isMockUser && (
              <GetApiResponses />
            )}
          </>
        )}

        {!currentlyImpersonating && (
          <>
            <div className={c.searchWrapper}>
              <h3>Impersonate users</h3>
              <UserSearch
                onSelect={startImpersonation}
                recentSearches={recentSearches}
                setRecentSearches={setRecentSearches}
              />
            </div>
            {Boolean(recentSearches.length) && (
              <RecentSearches
                recentSearches={recentSearches.slice(0, 10)}
                onSelect={startImpersonation}
              />
            )}
          </>
        )}
      </div>

      <IdSearch />
    </div>
  );
};

export default RealUsers;
